import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    countLabel: ({ count }: {
        count: number;
    }) => string | React.ReactNode;
    plusCountLabel: ({ count }: {
        count: number;
    }) => string | React.ReactNode;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Label showing match count only (narrow screen widths) */
            countLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => ({ count }: {
                        count: number;
                    }) => __intl__.intl().formatMessage({ id: "FeaturedFieldMatches.countLabel?c=3aigqlcjhf60v", defaultMessage: "{count} {count, plural, one {match} other {matches}}" }, { count: count }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label showing additional match count with pluralization */
            plusCountLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => ({ count }: {
                        count: number;
                    }) => __intl__.intl().formatMessage({ id: "FeaturedFieldMatches.plusCountLabel?c=3c3l34c5bul26", defaultMessage: "+{count} more {count, plural, one {match} other {matches}}" }, { count: count }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
